module.exports = __webpack_public_path__ + "static/img/325_TO8_2509_og.ccb0ac7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/325_TO8_2509_og.jpg
// module id = pCrr
// module chunks = 0